module.exports = __webpack_public_path__ + "static/media/sort-inactive.d5e651ae.svg";